import React, { useState } from 'react';
import bgPattern from "../assets/Log In.jpg";
import { useNavigate } from 'react-router-dom';

const ListingSelectionPage: React.FC = () => {
  const navigate = useNavigate();
  const [selectedOptions, setSelectedOptions] = useState<Set<string>>(new Set());

  const handleGetStarted = () => {
    navigate('/listing-onboarding');
  };

  const toggleOption = (optionLabel: string) => {
    setSelectedOptions(prev => {
      const newSet = new Set(prev);
      if (newSet.has(optionLabel)) {
        newSet.delete(optionLabel);
      } else {
        newSet.add(optionLabel);
      }
      return newSet;
    });
  };

  const options = [
    { id: 'listing-image', label: 'Listing Image' },
    { id: 'brand-story', label: 'Brand Story' },
    { id: 'premium-a++', label: 'Premium A++' }
  ];

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-tr from-[#E9E3FF] to-[#F8F6FF]" style={{
        backgroundImage: `url(${bgPattern})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}>
      <div className="bg-white rounded-[24px] shadow-lg p-12 w-full flex flex-col items-center" style={{paddingLeft: 100, paddingRight: 100, width: 962, marginTop: 88, marginBottom: 88, paddingTop: 67, paddingBottom: 67}} >
        <h1 className="mb-4 text-center font-roboto font-semibold" style={{fontSize: 32, color: '#4A3B8E'}}>Select your options to get started</h1>
        <p className="text-center mb-10 max-w-xl font-roboto font-normal" style={{fontSize: 18, color: '#85878B'}}>Select one or more types of Amazon Content you would like to optimize. Our AI will guide you through a personalized onboarding process</p>
        
        <div className="w-full space-y-4 mb-10 flex flex-col items-center">
          {options.map((option) => (
            <div
              key={option.id}
              className={`p-4 rounded-lg border-2 cursor-pointer transition-colors ${
                selectedOptions.has(option.label)
                  ? 'border-[#564DB8] bg-[#F6F3FF]'
                  : 'border-gray-200 bg-[#F6F3FF] hover:border-gray-300'
              }`}
              style={{width: 440}}
              onClick={() => toggleOption(option.label)}
            >
              <div className="flex items-center justify-between">
                <span className="font-roboto font-medium text-lg text-[#4A3B8E]">{option.label}</span>
                <div className={`w-6 h-6 rounded border-2 flex items-center justify-center ${
                  selectedOptions.has(option.label)
                    ? 'border-[#564DB8] bg-[#564DB8]'
                    : 'border-gray-300 bg-white'
                }`}>
                  {selectedOptions.has(option.label) && (
                    <svg width="14" height="10" viewBox="0 0 14 10" fill="none">
                      <path d="M1 5L5 9L13 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <button 
          className="text-white font-semibold text-base transition-colors" 
          onClick={handleGetStarted}
          style={{
            width: 440,
            padding: '12px',
            borderRadius: '12px',
            background: 'linear-gradient(90deg, #362E7F 0%, #5A4ABE 45.67%, #7F60BF 100%)'
          }}
        >
          Get Started
        </button>
      </div>
    </div>
  );
};

export default ListingSelectionPage; 